import React from 'react';

const SpacedText = ({ text, className = "" }) => {
  // Split text into words for left-to-right reveal animation
  const words = text.split(' ').map((word, index) => (
    <span 
      key={index} 
      className="inline-block opacity-0 animate-slide-in-left" 
      style={{ animationDelay: `${index * 0.15}s`, animationFillMode: 'forwards' }}
    >
      {word}
      {index < text.split(' ').length - 1 && '\u00A0\u00A0'}
    </span>
  ));

  return (
    <h2 className={`font-bold ${className}`}>
      {words}
    </h2>
  );
};

export default SpacedText;